import { BatchDetailsMap, Invoice, OrderType, ReturnableInvoiceDetails, ReturnSkuDetail, SalesBatchId, SalesDetail, SalesDetailsTaxInfo, SalesReasonDetails, SalesReturnDetail, TaxInfo, TaxMap,
  ReturnBatchDetails,
 } from "../../types/types";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";
import moment from "moment";
import dayjs from "dayjs";
import { getDataFromLocalDb, getModel, insertDataIntoLocalDB } from "../../services/dbService";
import { getOutletDetails, getPieceFilterMapping } from "../createSecondaryOrder/CreateSecondaryOrderService";
import { getOutletDetailsMap } from "../deliveryConfirmation/DeliveryConfirmationService";
import { getPricingData } from "../../services/catalogueService";
import { ProductMetadata } from "../createSecondaryOrder/models";
import { getNqQuantity } from "../stocks/manualStockAdjustment/ManualStockAdjustmentUtils";
import { setBatchWiseStockDataInDb } from "../stocks/batchAndExpiryManagement/BatchAndExpiryManagementUtils";
import { truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";

export const fetchSalesReturnData = async (startDate?: string, endDate?: string, invoiceNumber?: string, returnData?: any): Promise<SalesReturnDetail[]> => {
  try {
    // const salesReturnData = (await ChannelkartNetworkGet(`/v1/sales?size=1000&filter=creationTime[gte]:${moment(startDate + " 00:00:00").utc().format("YYYY-MM-DD HH:mm:ss")} and creationTime[lte]:${moment(endDate + " 23:59:59").utc().format("YYYY-MM-DD HH:mm:ss")} and type:return`)).data;
    let apiUrl = `/v3/sales?includeSalesDetails=true&size=1000&transformerOut=DMSInvoiceAPITransformer&filter=type:return and status[nin]:[INVOICED]`;
    
    if (startDate && endDate) {
      apiUrl += ` and creationTime[gte]:${moment(startDate + " 00:00:00").format("YYYY-MM-DD HH:mm:ss")}`;
      apiUrl += ` and creationTime[lte]:${moment(endDate + " 23:59:59").format("YYYY-MM-DD HH:mm:ss")}`;
    }
    
    if (invoiceNumber) {
      apiUrl += ` and invoiceNumber:${invoiceNumber}`;
    }

    const salesReturnData = returnData ?? (await ChannelkartNetworkGet(apiUrl)).data.features;
    console.log("salesReturnData",salesReturnData);
        // Sort salesReturnData based on creationTime in descending order
    salesReturnData.sort((a: any, b: any) => new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime());

    // Extract all invoice numbers (stored in referenceNumber field) from the return data
    const invoiceNumbers = salesReturnData.map((salesReturn: any) => salesReturn.referenceNumber).filter(Boolean);

    // Fetch the original invoice data for these invoice numbers
    let originalInvoiceData: any[] = [];
    // Create a map of invoice numbers to loadout data
    // const loadoutMap: Record<string, any> = {};
    
    if (invoiceNumbers.length > 0) {
      try {
        // Process invoice numbers in batches of 30
        const batchSize = 30;
        
        // Store loadout data from all batches
        // let loadoutData: any[] = [];
        
        for (let i = 0; i < invoiceNumbers.length; i += batchSize) {
          const batchInvoiceNumbers = invoiceNumbers.slice(i, i + batchSize);
          const invoiceResponse = (await ChannelkartNetworkGet(`/v3/sales?includeSalesDetails=true&size=${batchSize}&filter=invoiceNumber[in]:[${batchInvoiceNumbers.join(',')}]`)).data.features;
          // const loadooutResponse = await ChannelkartNetworkGet(`${EnvironmentRegistry.getloadoutBaseUrl()}/v1/loadoutDetails?filter_loadOutStatus_eq=DELIVERED&filter_invoiceNumber_in=${batchInvoiceNumbers.join(',')}`);

          if (invoiceResponse) {
            originalInvoiceData = [...originalInvoiceData, ...invoiceResponse];
          }
          
          // Collect loadout data
          // if (loadooutResponse && loadooutResponse.data && loadooutResponse.data.content) {
          //   loadoutData = [...loadoutData, ...loadooutResponse.data.content];
          // }
        }
        
        // Populate the loadout map
        // loadoutData.forEach((loadout: any) => {
        //   if (loadout.invoiceNumber) {
        //     loadoutMap[loadout.invoiceNumber] = loadout;
        //   }
        // });
      } catch (error) {
        console.error("Error fetching original invoice data:", error);
      }
    }

    let salesmanRouteMap: Record<string, string> = {};
    const suppliers = Array.from(new Set(salesReturnData.map((inv: any) => inv.supplier).filter(Boolean)));

    for (const supplier of suppliers) {
      try {
        const routeResponse = await ChannelkartNetworkGet(
          `/v1/route?filter=${encodeURIComponent(`supplier:${supplier}`)}`
        );

        routeResponse.data.features.forEach((route: any) => {
          if (route.salesmanCode && route.routeCode) {
            const key = `${supplier}_${route.salesmanCode}`;
            salesmanRouteMap[key] = route.routeCode;
          }
        });
      } catch (e) {
        console.error(`Failed to fetch routes for supplier ${supplier}:`, e);
      }
    }

    const invoiceSupplierMap:any = {};
    // Create a map of invoice numbers to their sold quantities
    const invoiceQuantityMap: Record<string, { soldCaseQty: number, soldPieceQty: number, soldOtherQty: number }> = {};
    originalInvoiceData.forEach((invoice: any) => {
      const soldCaseQty = invoice.salesDetails?.reduce((sum: number, item: any) =>
        sum + Math.abs(item.caseQuantity ?? 0), 0) || 0;

      const soldPieceQty = invoice.salesDetails?.reduce((sum: number, item: any) =>
        sum + Math.abs(item.initialPieceQuantity ?? 0), 0) || 0;

      const soldOtherQty = invoice.salesDetails?.reduce((sum: number, item: any) =>
        sum + Math.abs(item.otherUnitQuantity ?? 0), 0) || 0;

      // Store using the invoiceNumber as the key, since this will match with referenceNumber in returns
      if (invoice.invoiceNumber) {
        invoiceSupplierMap[invoice.invoiceNumber] = invoice.supplier;
        invoiceQuantityMap[invoice.invoiceNumber] = {
          soldCaseQty,
          soldPieceQty,
          soldOtherQty
        };
      }
    });

    const outletDetails = await getOutletDetailsMap();
    const routeMappingData = (await getDataFromLocalDb("RouteNameIdMapping")).data[0]?.data;

    return salesReturnData.map((salesReturn: any) => {
      const outletName = outletDetails[salesReturn.outletCode]?.outletName ?? "";
      const keyAccount = outletDetails[salesReturn.outletCode]?.keyAccount === "Y" || outletDetails[salesReturn.outletCode]?.keyAccount === "true" || outletDetails[salesReturn.outletCode]?.keyAccount === true;

      // Find matching loadout data if available
      // const loadout = loadoutMap && loadoutMap[salesReturn.referenceNumber];

      // Calculate return quantities from salesDetails
      const returnPieceQty = salesReturn.salesDetails?.reduce((sum: number, item: any) =>
        sum + Math.abs(item.initialPieceQuantity ?? 0), 0) || 0;

      const returnCaseQty = salesReturn.salesDetails?.reduce((sum: number, item: any) =>
        sum + Math.abs(item.caseQuantity ?? 0), 0) || 0;

      const returnOtherQty = salesReturn.salesDetails?.reduce((sum: number, item: any) =>
        sum + Math.abs(item.otherUnitQuantity ?? 0), 0) || 0;

      // Get sold quantities from the map using referenceNumber as the key to match with invoiceNumber
      // in the original invoice data
      const soldQuantities = invoiceQuantityMap[salesReturn.referenceNumber] || {
        soldCaseQty: 0,
        soldPieceQty: 0,
        soldOtherQty: 0
      };


      //get routeName for putting in column 
      

      const routeCode = salesmanRouteMap[`${salesReturn.supplier}_${salesReturn.loginId}`] || "";
      const routeName = routeCode && routeMappingData?.[routeCode] ? routeMappingData?.[routeCode]?.filter1 : "";

      return {
        id: salesReturn.invoiceNumber,
        returnNumber: salesReturn.invoiceNumber,
        invoiceNumber: salesReturn.referenceNumber,
        invoiceNumberToDisplay: salesReturn.referenceNumber ?? "-",
        status: salesReturn.status || "PENDING", // Default status if not provided
        saleCondition: salesReturn.saleCondition,
        source: salesReturn.source || "-",
        // loadoutNumber: loadout ? loadout.loadNumber || "-" : "-",
        deliveryDate: "",
        // deliveryRoute: loadout ? loadout.routeCode || "-" : "-",
        vehicleNumber: "",
        supplier: invoiceSupplierMap[salesReturn.referenceNumber],
        returnDate:dayjs(salesReturn.creationTime).format("DD-MM-YYYY"),
        outletName: outletName,
        outletCode: salesReturn.outletCode,
        keyAccount: keyAccount ? true : false,
        returnAmount: Math.abs(salesReturn.netAmount ?? 0),
        returnPieceQty: returnPieceQty,
        returnCaseQty: returnCaseQty,
        returnOtherQty: returnOtherQty,
        soldCaseQty: soldQuantities.soldCaseQty,
        soldPieceQty: soldQuantities.soldPieceQty,
        soldOtherQty: soldQuantities.soldOtherQty,
        routeCode,
        routeName,
        salesRepName: salesReturn.salesRepName || "-",
        salesRepId: salesReturn.salesRepId || "-",
      } as SalesReturnDetail;
    });
  } catch (error) {
    console.error("Error fetching sales return data:", error);
    throw error;
  }
};

export const getReturnableInvoiceDetails = async (fetchPricingBySalesrep:boolean) => {
  const salesReturnData = [];
  let index = 0;
  const size = 1000;
  while (1) {
    const data = (await ChannelkartNetworkGet(`/delivery/sales/noReturn?size=${size}&page=${index}`)).data.features;
    
    salesReturnData.push(...data);
    // if (data.length < size) {
      break;
    // }
    index++;
    
  }
  
  const user = JSON.parse(localStorage.getItem('authContext') ?? "")?.user;
  const outletDetails = await getOutletDetailsMap();
  const outletNameDetails: any = {};
  const outletCodeDetails: any = {};
  const outletSalesManNameDetails: any ={};
  const outletSalesManIdDetails: any ={};

  Object.keys(outletDetails).forEach((key: any) => {
    if(key === user.loginId){
      return;
    }
    const outlet = outletDetails[key];
    outletCodeDetails[outlet.outletCode] = outlet;
    outletNameDetails[outlet.outletName] = outlet;
  })
    
//salesman details
  const salesManDetails = fetchPricingBySalesrep ? (await ChannelkartNetworkGet(
          "/users/mapped/hierarchy?filter=activeStatus:active and designation[in]:[salesman]&size=10000&source=portal"
        )).data.features : []
  salesManDetails.forEach((details:any)=>{
    outletSalesManNameDetails[details.name]= details;
    outletSalesManIdDetails[details.loginId]=details;
  });

// outlet details
  // Filter out sales data that don't have valid outlet details to prevent unmapped outlets from polluting the list
  const returnableData: ReturnableInvoiceDetails[] = salesReturnData
    .filter((sales: any) => outletDetails[sales.outletcode]) // Only keep sales with valid outlets in user's hierarchy
    .map((sales: any) => {
      const formattedCreationTime = dayjs(sales.creation_time, "YYYY-MM-DD").format("DD-MM-YYYY");
      return {
        invoiceNumber: sales.invoice_number,
        outletCode: sales.outletcode,
        deliveryDate: dayjs(sales.deliveryDate).format('DD-MM-YYYY'),
        outletName: outletDetails[sales.outletcode]?.outletName,
        creationTime: formattedCreationTime,
        salesMan: sales.loginid,
        salesManName: outletSalesManIdDetails[sales.loginid],
        routeId: sales.beat || "",
      };
    });

  //beat details
  const supplier= JSON.parse(localStorage.getItem('authContext') ?? "")?.user?.loginId;

  const withoutInvoiceRouteMap:{[key: string]: any} = {};
  const withInvoiceRouteMap: { [key: string]: any } = {};
  const routeIdAndSalesManCodeMap:{[key: string]: any} = {};
  const routeIdAndNameMap: {[key: string]: any} = {};

  if(fetchPricingBySalesrep){
    const routeIdAndName = await ChannelkartNetworkGet(
    `/v1/route?filter=${encodeURIComponent(`supplier:${supplier}`)}`
    );
    const routeMappingData = (await getDataFromLocalDb("RouteNameIdMapping")).data[0]?.data;

    routeIdAndName.data.features.forEach((route: any) => {
      const salesman = route.salesmanCode;
      const routeCode = route.routeCode;
      const routeName = routeMappingData?.[routeCode]?.filter1 || "";
      const key= `${routeName}-${routeCode}`;
      const invoiceKey= `${routeCode}-${routeName}`;

      if(routeIdAndNameMap[routeName]){
        const existingRouteData = routeIdAndNameMap[routeName];
        const updatedKey= `${routeName}-${existingRouteData.routeCode}`;
        routeIdAndNameMap[updatedKey]= existingRouteData;
        delete routeIdAndNameMap[routeName];
        routeIdAndNameMap[key]= {...route, routeName: routeName || ""};
      }else{
        routeIdAndNameMap[routeName]= {...route, routeName: routeName || ""};
      }

      if (!salesman) return;
      withoutInvoiceRouteMap[invoiceKey]= salesman;
      routeIdAndSalesManCodeMap[routeCode] = routeIdAndSalesManCodeMap[routeCode] ?? [];
      routeIdAndSalesManCodeMap[routeCode].push(salesman);  
    });


    //withinvoice
    returnableData.forEach((invoice) => {
      const routeKey = invoice.routeId && routeMappingData?.[invoice.routeId] ? `${invoice.routeId}-${routeMappingData?.[invoice.routeId]?.filter1}` : null;
      if (routeKey && !withInvoiceRouteMap[routeKey]) {
        withInvoiceRouteMap[routeKey] = invoice;
      } else {
        const existingCreationTime = dayjs(routeKey && withInvoiceRouteMap[routeKey].creationTime, "DD-MM-YYYY");
        const newCreationTime = dayjs(invoice.creationTime, "DD-MM-YYYY");
        if (routeKey && newCreationTime.isAfter(existingCreationTime)) {
          withInvoiceRouteMap[routeKey] = invoice;
        }
      }
    })
  }

  return { outletCodeDetails, outletNameDetails, returnableData, withInvoiceRouteMap, outletSalesManNameDetails, outletSalesManIdDetails, salesManDetails, withoutInvoiceRouteMap, routeIdAndSalesManCodeMap, routeIdAndNameMap};
}

export const getBatchDetailsFromDb: (featureName ?: string) => Promise<BatchDetailsMap | null> = async (featureName ?: string) => {
  const batchDetails = (await getDataFromLocalDb("application_data", { property: "batchDetails" + (featureName ? "-"+featureName : "") })).data
  return batchDetails.length ? batchDetails[0].value : null;
}


export const setBatchDetailsInDb = async (batchDetails: BatchDetailsMap , featureName ?: string) => {
  await insertDataIntoLocalDB("application_data", [{ value: batchDetails, property: "batchDetails" + (featureName ? "-"+featureName : "")}])
}

export const clearBatchDetailsInDb = async (featureName ?: string) => {
  const model = await getModel("application_data");
  await model.delete({ property: "batchDetails" + (featureName ? "-"+featureName : "") })
}

export const fetchAndSaveProductDetails = async (outletCode:string, isPricingRequired: boolean, salesRepId: string,)=>{
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const batchIdConfiguration = ConfigDictionary?.batchIdConfiguration;
  const fetchPricingBySalesrep = ConfigDictionary?.fetchPricingBySalesrep;
  await clearProductDetailsInDb();
  let productData: any = [];
  let productDataMap: any = [];
      try {
        productDataMap = (await getDataFromLocalDb("Product")).data[0].data;
        productData = Object.values(productDataMap);
      } catch (e) { }
  const batchWiseStockData = await setBatchWiseStockDataInDb();
  const batchWiseStockDataMap:any = {};
  batchWiseStockData.forEach((batch:any)=>{
    batchWiseStockDataMap[batch.batchCode+"_"+batch.batchId] = batch;
  })
  const pricingDataMap:{[batchCode: string]: ProductMetadata} = {};
  const skuCodes:string[] = [];
  if(batchIdConfiguration && fetchPricingBySalesrep && isPricingRequired){
    const skuMapping = (await ChannelkartNetworkGet(`/v1/entitymapping?entityType=user&entityId=${salesRepId}`)).data.features.find((feature:any)=>feature.entityCategory === "sku_line_mapping");
    skuCodes.push(...skuMapping.productInfo.map((product:any)=>product.skuCode));
  }else{
    skuCodes.push(...Object.keys(productDataMap));
  }
  const loginId = JSON.parse(localStorage.getItem("authContext") || "{}")?.user?.loginId;
  const pricingData = (batchIdConfiguration && fetchPricingBySalesrep) ? (await ChannelkartNetworkGet(`/productmetadata/v1/supplier/${loginId}/products`)).data.products : await getPricingData(outletCode, salesRepId ?? "", OrderType.SECONDARY, false);
  pricingData.forEach(async (pricing: any) => {
    if(skuCodes.includes(pricing.skuCode)){
      pricing.batchIdDetails = pricingDataMap[pricing.batchCode]?.batchIdDetails ?? [];
      const expiryDate = getExpiryDate(batchWiseStockDataMap[pricing.batchCode+"_"+pricing.batchId]);
      pricing.batchIdDetails!.push({
        batchId: pricing.batchId,
        mrp: pricing.mrp,
        packPtr: pricing.packPtr,
        expiryDate
      });
      pricingDataMap[pricing.batchCode] = pricing;

    }
  })
  const newProductData:any = {};

  productData.forEach((product: any) => {
    if((isPricingRequired) && !pricingDataMap[product.batchCode]){
      return;
    }
    product.price = pricingDataMap[product.batchCode]?.packPtr;
    product.batchIdDetails = pricingDataMap[product.batchCode]?.batchIdDetails;
    newProductData[product.batchCode] = product;
  })
  await setProductDetailsInDb(newProductData);
  return newProductData;
}

const getExpiryDate = (batchStockData:any)=>{
  if(!batchStockData){
    return "";
  }
  const expiryDate = batchStockData.pieceQty?.expiryDate || batchStockData.caseQty?.expiryDate || batchStockData.otherQty?.expiryDate || "";
  return expiryDate ? dayjs(expiryDate).format("DD/MM/YYYY") : "";
}

const fetchDataInBatches = async(url:string)=>{
  const size = 1000;
  let index = 0;
  const allData = [];
  while (1) {
    const data = (await ChannelkartNetworkGet(`${url}&size=${size}&page=${index}`)).data.features;
    allData.push(...data);
    if (data.length < size) {
      break;
    }
    index++;
  }
  return allData;
}

export const getProductDetailsFromDb: () => Promise<any> = async () => {
  const batchDetails = (await getDataFromLocalDb("application_data", { property: "productDetails" })).data
  return batchDetails.length ? batchDetails[0].value : null;
}

export const getAllProductDetailsFromDb: () => Promise<any> = async () => {
  return (await getDataFromLocalDb("Product")).data[0].data
}

export const setProductDetailsInDb = async (productDetails: any) => {
  await insertDataIntoLocalDB("application_data", [{ value: productDetails, property: "productDetails" }])
}

export const clearProductDetailsInDb = async () => {
  const model = await getModel("application_data");
  await model.delete({ property: "productDetails" })
}

export const getReturnData = async (returnNumber: string) => {
  const returnDetails = (await ChannelkartNetworkGet(`/v3/sales?includeSalesDetails=true&size=10&filter=invoiceNumber:${returnNumber}`)).data.features[0];
  const negFields = ['netAmount','caseQuantity','initialAmount','initialPieceQuantity','otherUnitQuantity'];
  negFields.forEach((field: string) => {
    returnDetails[field] = Math.abs(returnDetails[field] ?? 0);
  })
  return returnDetails
}

export const setBatchDetailsFromReturns = async(returnNumber:string, returnData?: any, fetureName?: string)=>{
  await clearBatchDetailsInDb();
  const batchDetails:BatchDetailsMap = {};
  const returnAmountMap:any = {};
  const returnDetails = returnData ?? (await ChannelkartNetworkGet(`/v3/sales?includeSalesDetails=true&size=10&filter=invoiceNumber:${returnNumber}`)).data.features[0];
  returnDetails.salesDetails.forEach((salesDetail: SalesDetail) => {
    returnAmountMap[salesDetail.batchCode] = returnAmountMap[salesDetail.batchCode] ?? 0;
    returnAmountMap[salesDetail.batchCode] += Math.abs(salesDetail.netAmount);
    batchDetails[salesDetail.batchCode] = batchDetails[salesDetail.batchCode] ?? {};
    salesDetail.batchIds?.forEach((batch: SalesBatchId) => {
      batchDetails[salesDetail.batchCode][batch.batchId] = batch.reasonDetails ?? [];
    })
  })
  await setBatchDetailsInDb(batchDetails, fetureName);
  return {batchDetails, returnAmountMap};
}

export const getInvoiceDetails = async (invoiceNumber: string, productData?: any) => {

  const invoiceDetails = (await ChannelkartNetworkGet(`/v3/sales?includeSalesDetails=true&size=10&filter=invoiceNumber:${invoiceNumber}`)).data.features[0];
  if(!productData){
    try {
      productData = (await getDataFromLocalDb("Product")).data[0].data;
    } catch (e) { }
  }
  invoiceDetails.salesDetails.forEach((salesDetail: SalesDetail) => {
    const pieceSize = productData[salesDetail.batchCode].pieceSize;
    salesDetail.skuName = salesDetail.productInfo.skuDescription;
    salesDetail.batchIdCount = salesDetail.batchIds ? salesDetail.batchIds.length : 0;
    salesDetail.packType = getPieceFilterMapping(pieceSize);
    salesDetail.soldCaseQty = salesDetail.caseQuantity;
    salesDetail.soldOtherQty = salesDetail.otherUnitQuantity;
    salesDetail.soldPieceQty = salesDetail.initialPieceQuantity;
    salesDetail.totalCaseQty = salesDetail.caseQuantity;
    salesDetail.totalOtherQty = salesDetail.otherUnitQuantity;
    salesDetail.totalPieceQty = salesDetail.initialPieceQuantity;
    salesDetail.returnCaseQty = 0;
    salesDetail.returnOtherQty = 0;
    salesDetail.returnPieceQty = 0;
    salesDetail.discountPercentage = calculateDiscountPercentage(salesDetail);
  })
  return invoiceDetails
}

export const getReturnDetails = async (referenceNumber: string, productData?: any) => {
  if (!productData) {
    try {
      productData = (await getDataFromLocalDb("Product")).data[0].data;
    } catch (e) {
      console.error("Error fetching product data from local DB:", e);
      return {
        referenceNumber: "",
        netNormalizedQty: 0,
        skuDetailsSummary: {},
        batchDetails: {}
      };
    }
  }

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const batchIdConfiguration = ConfigDictionary?.batchIdConfiguration;

  let finalBatchSummary: ReturnBatchDetails = {
    referenceNumber: "",
    netNormalizedQty: 0,
    skuDetailsSummary: {},
    batchDetails: {},
    returnDetails:[]
  };

  let netNormalizedQty = 0;

  try {
    const response = await ChannelkartNetworkGet(
      `/v3/sales?includeSalesDetails=true&size=1000&filter=referenceNumber:${referenceNumber}&source=portal`
    );
    console.log("Response for reference number:", response);

    if (!response?.data) {
      console.error("No data in response:", response);
      return {
        referenceNumber: "",
        netNormalizedQty: 0,
        skuDetailsSummary: {},
        batchDetails: {},
        returnDetails:[]
      };
    }

    const returnDetails = response.data.features;
    
    
    const batchDetails: any = {}; 
    const skuDetailsSummary: any = {};
    if (returnDetails?.length > 0) {
      for (const feature of returnDetails) {
        for(const salesDetail of feature.salesDetails){
          
          if (!salesDetail?.batchCode) continue;
          
          const featureObj = {
            skuCode: salesDetail.skuCode,
            totalCaseQty: salesDetail.caseQuantity,
            totalPieceQty: salesDetail.initialPieceQuantity,
            totalOtherQty: salesDetail.otherUnitQuantity,
          };
          
          const featureObjNormalizedQty = await getNqQuantity(
            featureObj, 
            productData[salesDetail.batchCode]
          );
          netNormalizedQty += featureObjNormalizedQty;
  
          
          if (salesDetail?.batchIds?.length) {
            for (const batchId of salesDetail.batchIds) {
              const batchIdsQty = {
                totalCaseQty: batchId.caseQty,
                totalPieceQty: batchId.pieceQty,
                totalOtherQty: batchId.otherQty,
                skuCode: salesDetail.batchCode,
              };
  
              const normalizedBatchQty = await getNqQuantity(
                batchIdsQty, 
                productData[salesDetail.batchCode]
              );
  
              if (!batchDetails[ salesDetail.batchCode + "_" + batchId.batchId]) {
                batchDetails[ salesDetail.batchCode + "_" + batchId.batchId] = Math.abs(normalizedBatchQty);
              } else {
                batchDetails[ salesDetail.batchCode + "_" + batchId.batchId] += Math.abs(normalizedBatchQty);
              }

            }
          }

          const existingFeatureIndex = skuDetailsSummary[salesDetail.batchCode + (batchIdConfiguration ? "_" + salesDetail.batchId : "")];
          if (!existingFeatureIndex) {
            skuDetailsSummary[salesDetail.batchCode + (batchIdConfiguration ? "_" + salesDetail.batchId : "")] = Math.abs(featureObjNormalizedQty);
          } else {
            skuDetailsSummary[salesDetail.batchCode + (batchIdConfiguration ? "_" + salesDetail.batchId : "")] += Math.abs(featureObjNormalizedQty);
          }
        }
      }
      finalBatchSummary = {
        referenceNumber,
        netNormalizedQty,
        skuDetailsSummary,
        batchDetails,
        returnDetails
      };
    }
  } catch (error) {
    console.error("Error in getReturnDetails:", error);
    return {
      referenceNumber: "",
      netNormalizedQty: 0,
      skuDetailsSummary: {},
      batchDetails: {},
      returnDetails:[]
    };
  }
  return finalBatchSummary;
};



export const calculateDiscountPercentage = (salesDetail: SalesDetail) => {
  if(!salesDetail.discountInfo){
    return 0;
  }
  const discountAmount = salesDetail.discountInfo.reduce((acc:any, discount:any) => acc + discount.finalBenefit, 0);;
  return (discountAmount / salesDetail.initialAmount) * 100;
}

const calculateNq = (salesDetail: SalesDetail, productData:any)=>{
    const skuDetails = productData[salesDetail.batchCode];
    if(!skuDetails){
      return salesDetail.initialPieceQuantity;
    }
    let nq = salesDetail.initialPieceQuantity;
    if(skuDetails.caseToPieceQuantity){
      nq+=skuDetails.caseToPieceQuantity * salesDetail.caseQuantity;
    }
    if(skuDetails.otherUnitToPieceQuantity){
      nq+=skuDetails.otherUnitToPieceQuantity * salesDetail.otherUnitQuantity;
    }
    return nq;
}

export const getBatchIdsFromMap = (batchDetails: { [key: string]: SalesReasonDetails[] }) => {
  return Object.keys(batchDetails).map(batchId => {
    let caseQty = 0, pieceQty = 0, otherQty = 0;
    batchDetails[batchId].forEach(reasonDetail => {
      caseQty += reasonDetail.caseQty;
      pieceQty += reasonDetail.pieceQty;
      otherQty += reasonDetail.otherQty;
    })
    return {
      "batchId": batchId,
      "caseQty": caseQty,
      "otherQty": otherQty,
      "pieceQty": pieceQty,
      "reasonDetails": JSON.parse(JSON.stringify(batchDetails[batchId]))
    }
  });
}

// Helper function to calculate quantities by sale condition
const calculateQuantitiesByCondition = (salesDetail: SalesDetail, saleCondition: string) => {
  const caseQty = salesDetail.batchIds?.reduce((total, batchId) => 
    total + (batchId?.reasonDetails?.reduce((total, reasonDetail) => 
      total + (reasonDetail.saleCondition === saleCondition ? reasonDetail.caseQty : 0), 0) ?? 0), 0) ?? 0;
  
  const pieceQty = salesDetail.batchIds?.reduce((total, batchId) => 
    total + (batchId?.reasonDetails?.reduce((total, reasonDetail) => 
      total + (reasonDetail.saleCondition === saleCondition ? reasonDetail.pieceQty : 0), 0) ?? 0), 0) ?? 0;
  
  const otherQty = salesDetail.batchIds?.reduce((total, batchId) => 
    total + (batchId?.reasonDetails?.reduce((total, reasonDetail) => 
      total + (reasonDetail.saleCondition === saleCondition ? reasonDetail.otherQty : 0), 0) ?? 0), 0) ?? 0;
  
  return { caseQty, pieceQty, otherQty };
};

// Helper function to create batch IDs with filtered reason details
const createBatchIdsWithCondition = (batchIds: SalesBatchId[] | undefined, saleCondition: string) => {
  return batchIds?.map((batchIdObject: SalesBatchId) => {
    const updatedBatch: SalesBatchId = {
      batchId: batchIdObject.batchId,
      caseQty: batchIdObject.caseQty,
      otherQty: batchIdObject.otherQty,
      pieceQty: batchIdObject.pieceQty,
      reasonDetails: batchIdObject.reasonDetails?.filter(reasonDetail => reasonDetail.saleCondition === saleCondition)
    }
    let caseQty = 0, pieceQty = 0, otherQty = 0;
    updatedBatch.reasonDetails?.forEach(reasonDetail => {
      caseQty += reasonDetail.caseQty;
      pieceQty += reasonDetail.pieceQty;
      otherQty += reasonDetail.otherQty;
    });
    
    updatedBatch.caseQty = caseQty;
    updatedBatch.otherQty = otherQty;
    updatedBatch.pieceQty = pieceQty;
    return updatedBatch;
  });
};

// Helper function to create sales detail object
const createSalesDetail = (salesDetail: SalesDetail, invoiceData: Invoice, quantities: { caseQty: number, pieceQty: number, otherQty: number }, saleCondition: string, batchIds?: SalesBatchId[]) => ({
  supplier: invoiceData.supplier,
  skuCode: salesDetail.skuCode,
  price: salesDetail.price,
  saleCondition: saleCondition,
  extendedAttributes: {
    saleCondition: saleCondition,
  },
  batchCode: salesDetail.batchCode,
  pieceQuantity: quantities.pieceQty,
  caseQuantity: quantities.caseQty,
  otherUnitQuantity: quantities.otherQty,
  batchIds: batchIds
});

// Helper function to create base request body
const createBaseRequestBody = (invoiceData: Invoice, returnNumber?:string) => ({
  referenceNumber: invoiceData.invoiceNumber,
  invoiceNumber:returnNumber,
  supplier: invoiceData.supplier,
  loginId: invoiceData.loginId,
  source: "DMS",
  outletCode: invoiceData.outletCode,
  extendedAttributes: {
    returnStatus: "APPROVED"
  }
});

export const getSalesReturnReqBody = (invoiceData: Invoice, returnNumber?:string) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const batchIdConfiguration = ConfigDictionary?.batchIdConfiguration;
  const reasonMap: { [key: string]: string[] } = ConfigDictionary?.salesReturnReasonsMap ?? {};
  
  const baseBody = createBaseRequestBody(invoiceData, returnNumber);
  const filteredSalesDetails = invoiceData.salesDetails.filter(
    (salesDetail: SalesDetail) => salesDetail.returnCaseQty || salesDetail.returnOtherQty || salesDetail.returnPieceQty
  );

  if (Object.keys(reasonMap).length === 0) {
    // Simple case - no reason map
    return {
      ...baseBody,
      salesDetails: filteredSalesDetails.map((salesDetail: SalesDetail) => 
        createSalesDetail(salesDetail, invoiceData, {
          caseQty: salesDetail.returnCaseQty,
          pieceQty: salesDetail.returnPieceQty,
          otherQty: salesDetail.returnOtherQty
        }, 
        "Saleable",
        salesDetail.batchIds?.map((batchIdObject: SalesBatchId) => {
          const updatedBatch = JSON.parse(JSON.stringify(batchIdObject));
          let caseQty = 0, pieceQty = 0, otherQty = 0;
          batchIdObject.reasonDetails?.forEach(reasonDetail => {
            caseQty += reasonDetail.caseQty;
            pieceQty += reasonDetail.pieceQty;
            otherQty += reasonDetail.otherQty;
          });
          updatedBatch.caseQty = caseQty;
          updatedBatch.otherQty = otherQty;
          updatedBatch.pieceQty = pieceQty;
          return updatedBatch;
        }))
      )
    };
  } else {
    // Complex case - with reason map, split by sale condition
    const salesDetails = filteredSalesDetails.flatMap((salesDetail: SalesDetail) => {
      const saleableQuantities = calculateQuantitiesByCondition(salesDetail, "Saleable");
      const unsaleableQuantities = calculateQuantitiesByCondition(salesDetail, "Unsaleable");

      const result = [];
      if (saleableQuantities.caseQty || saleableQuantities.pieceQty || saleableQuantities.otherQty) {
        result.push(createSalesDetail(
          salesDetail, 
          invoiceData, 
          saleableQuantities,
          "Saleable",
          createBatchIdsWithCondition(salesDetail.batchIds, "Saleable")
        ));
      }
      
      if (unsaleableQuantities.caseQty || unsaleableQuantities.pieceQty || unsaleableQuantities.otherQty) {
        result.push(createSalesDetail(
          salesDetail, 
          invoiceData, 
          unsaleableQuantities,
          "Unsaleable",
          createBatchIdsWithCondition(salesDetail.batchIds, "Unsaleable")
        ));
      }
      
      return result;
    }).filter(salesDetail => salesDetail.caseQuantity || salesDetail.otherUnitQuantity || salesDetail.pieceQuantity);

    return {
      ...baseBody,
      salesDetails: batchIdConfiguration ? applyBatchIdSplitting({salesDetails}).salesDetails : salesDetails
    };
  }
};

export const approveSalesReturnWithoutInvoice = async (invoiceData: Invoice) => {
  const reqBody = {
    "invoiceNumber": invoiceData.invoiceNumber,
    "supplier": invoiceData.supplier,
    "loginId": invoiceData.loginId,
    "outletCode": invoiceData.outletCode,
    "type":"return",
    "status": "APPROVED",
    "extendedAttributes": {
      "recalculateAmount": true,
      "isNewSchemes": true
    }
  }
  return ChannelkartNetworkPut("/v1/sales/approveReturn", reqBody);
}

export const approveSalesReturnWithInvoice = async (invoiceData: Invoice) => {
  const reqBody = {
    "invoiceNumber": invoiceData.returnNumber,
    "supplier": invoiceData.supplier,
    "loginId": invoiceData.loginId,
    "outletCode": invoiceData.outletCode,
    "status": "APPROVED"
  }
  return ChannelkartNetworkPut("/v1/sales/approveReturn", reqBody);
}

export const editSalesReturn = async (invoiceData: Invoice) => {
  const reqBody = {
    "invoiceNumber":invoiceData.invoiceNumber,
    "supplier": invoiceData.supplier,
    "loginId": invoiceData.loginId,
    "outletCode": invoiceData.outletCode,
    "type":"return",
    "extendedAttributes": {
        "returnStatus": "APPROVED",
        "isNewSchemes": true,
        "return": true
    },
    "salesDetails": invoiceData.salesDetails
      .filter((salesDetail: SalesDetail) => salesDetail.caseQuantity || salesDetail.otherUnitQuantity || salesDetail.pieceQuantity)
      .map((salesDetail: SalesDetail) => ({
        "skuCode": salesDetail.skuCode,
        "batchCode": salesDetail.batchCode,
        "price": salesDetail.price,
        "pieceQuantity": salesDetail.pieceQuantity,
        "caseQuantity": salesDetail.caseQuantity,
        "otherUnitQuantity": salesDetail.otherUnitQuantity,
        "batchIds": salesDetail.batchIds
      }))
  }
  return ChannelkartNetworkPost("/v3/sales/dmsInvoice/edit", reqBody);
}

export const newEditSalesReturn = async (requestBody: any) => {
  return ChannelkartNetworkPut("/v1/sales/editSalesReturnWORefNum", requestBody);
}



export const rejectSalesReturnWithInvoice = async (invoiceData: Invoice, reason:string) => {
  const reqBody = {
    "invoiceNumber": invoiceData.returnNumber,
    "supplier": invoiceData.supplier,
    "loginId": invoiceData.loginId,
    "outletCode": invoiceData.outletCode,
    "statusReason": reason,
    "status": "REJECTED"
  }
  return ChannelkartNetworkPut("/v1/sales/rejectReturn", reqBody);
}

export const rejectSalesReturnWithoutInvoice = async (invoiceData: Invoice, reason:string) => {
  const reqBody = {
    "invoiceNumber": invoiceData.invoiceNumber,
    "supplier": invoiceData.supplier,
    "loginId": invoiceData.loginId,
    "outletCode": invoiceData.outletCode,
    "statusReason": reason,
    "status": "REJECTED"
  }
  return ChannelkartNetworkPut("/v1/sales/rejectReturn", reqBody);
}

const getTaxList = (taxMap: TaxMap, batchCode: string, taxType:string)=> {
  if (taxMap[taxType]) {
      const vatList:TaxInfo[] = taxMap[taxType];
      if (vatList) {
          return [vatList[0]];
      }
  }
  return taxMap[batchCode] ?? [];
}

const filterTaxList = (taxList:TaxInfo[], warehouseCheck:boolean, sameLocation:boolean) => {
  if(warehouseCheck){
    if(sameLocation){
      return taxList.filter(taxInfo => taxInfo.taxType.toLowerCase() != "igst");
    }else{
      return taxList.filter(taxInfo => taxInfo.taxType.toLowerCase() != "cgst" && taxInfo.taxType.toLowerCase() != "sgst");
    }
  }else{
    return [...taxList];
  }
}

export const calculateTaxAmount = (amount:number, taxInfo:SalesDetailsTaxInfo[])=>{
  let taxPercentage = 0;
  taxInfo.forEach(taxDetail => {
    taxPercentage+=parseFloat(taxDetail.taxPercent);
  })
  return amount * (taxPercentage/100);
}

export const calculateDiscountAmount = (amount:number, discountPercentage: number)=>{
  return amount * (discountPercentage/100);
}


export const getTaxDetails = async(outletCode:string, supplier:string, batchCodeList: string[])=>{
  try{
    return (await ChannelkartNetworkGet("/getTaxCalculationDetails?outletCode="+outletCode+"&supplier="+supplier+"&batchCodes="+batchCodeList)).data;
  }catch(error){
    return null;
  }
}

export const calculateReturnAmount = (salesDetails:SalesDetail)=>{
  const returnCaseQty = salesDetails.batchIds?.reduce((total, batchId) => total + (batchId?.reasonDetails?.reduce((total, reasonDetail) => total + reasonDetail.caseQty, 0) ?? 0), 0) ?? 0;
  const returnPieceQty = salesDetails.batchIds?.reduce((total, batchId) => total + (batchId?.reasonDetails?.reduce((total, reasonDetail) => total + reasonDetail.pieceQty, 0) ?? 0), 0) ?? 0;
  const returnOtherQty = salesDetails.batchIds?.reduce((total, batchId) => total + (batchId?.reasonDetails?.reduce((total, reasonDetail) => total + reasonDetail.otherQty, 0) ?? 0), 0) ?? 0;

  const amount = returnCaseQty * salesDetails.casePrice + returnPieceQty * salesDetails.price + returnOtherQty * salesDetails.otherUnitPrice;
  const taxAmount = salesDetails.extendedAttributes?.taxInfo ? calculateTaxAmount(amount, salesDetails.extendedAttributes?.taxInfo) : 0;
  // const discountAmount = salesDetails.discountPercentage ? calculateDiscountAmount(amount, salesDetails.discountPercentage) : 0;
  return parseFloat(truncateToTwoDecimals(amount + taxAmount));
}

export const validateReturnDetailsWithInvoice = async(invoiceDetails:Invoice)=>{
    const user = JSON.parse(localStorage.authContext).user;
    const batchDetailsMap = await getBatchDetailsFromDb();
    if(!batchDetailsMap){
      throw new Error("Return Details not found");
    }

    const reqBody = {
        "invoiceNumber":"test",
        "loginId":invoiceDetails.loginId,
        "supplier":invoiceDetails.supplier,
        "source":"DMS",
        "type":"return",
        "outletCode":invoiceDetails.outletCode,
        "salesDetails":invoiceDetails.salesDetails.map(returnDetails=>({
            "supplier":invoiceDetails.supplier,
            "skuCode":returnDetails.skuCode,
            "batchCode":returnDetails.batchCode,
            "price":returnDetails.price,
            "caseQuantity":returnDetails.returnCaseQty,
            "pieceQuantity":returnDetails.returnPieceQty,
            "otherUnitQuantity":returnDetails.returnOtherQty,
            "extendedAttributes":{}
        })).filter(returnDetailsObject=>returnDetailsObject.caseQuantity+returnDetailsObject.otherUnitQuantity+returnDetailsObject.pieceQuantity),
        "extendedAttributes":{
          "isNewSchemes":true,
        }
    };
    const response:any = await ChannelkartNetworkPost("/v3/sales/validate?transformerOut=SalesValidateTransformer",reqBody);
    return response.data.feature[0];
}

export const validateReturnDetails = async(outletCode:string, returnDetailsList:ReturnSkuDetail[], salesRepId:string, salesRepName:string, batchIdConfiguration:boolean)=>{
    const user = JSON.parse(localStorage.authContext).user;
    const batchDetailsMap = await getBatchDetailsFromDb();
    if(!batchDetailsMap){
      throw new Error("Return Details not found");
    }
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
    const reasonMap: { [key: string]: string[] } = ConfigDictionary?.salesReturnReasonsMap ?? {};
    let reqBody;
    // if(Object.keys(reasonMap).length == 0){
      reqBody = {
          "invoiceNumber":"test",
          "loginId":salesRepId ?? user.loginId,
          "supplier":user.loginId,
          "source":"DMS",
          "type":"return",
          "outletCode":outletCode,
          "salesDetails":returnDetailsList.map(returnDetails=>({
              "supplier":user.loginId,
              "skuCode":returnDetails.skuCode,
              "batchCode":returnDetails.batchCode,
              "price":returnDetails.ptr,
              "caseQuantity":returnDetails.caseQuantity,
              "pieceQuantity":returnDetails.pieceQuantity,
              "otherUnitQuantity":returnDetails.otherUnitQuantity,
              "batchIds":Object.keys(returnDetails.batchIds).map(batchId => ({
                "batchId":batchId,
                "caseQty":Object.values(returnDetails.batchIds[batchId]).reduce((acc, current) => acc + current.caseQty, 0),
                "otherQty":Object.values(returnDetails.batchIds[batchId]).reduce((acc, current) => acc + current.otherQty, 0),
                "pieceQty":Object.values(returnDetails.batchIds[batchId]).reduce((acc, current) => acc + current.pieceQty, 0),
                "reasonDetails":Object.values(returnDetails.batchIds[batchId])
              })),
              "extendedAttributes":{}
          })).filter(returnDetailsObject=>returnDetailsObject.caseQuantity+returnDetailsObject.otherUnitQuantity+returnDetailsObject.pieceQuantity),
          "extendedAttributes":{
            "isNewSchemes":true,
          }
      };
    // }else{
    //   reqBody = {
    //     "invoiceNumber":"test",
    //     "loginId":salesRepId ?? user.loginId,
    //     "supplier":user.loginId,
    //     "source":"DMS",
    //     "type":"return",
    //     "outletCode":outletCode,
    //     "salesDetails":returnDetailsList.flatMap(returnDetails=>{
    //       const saleableBatchIds = Object.keys(returnDetails.batchIds).filter(batchId => 
    //         returnDetails.batchIds[batchId].some(reason => reason.saleCondition === "Saleable")
    //       );
    //       const unsaleableBatchIds = Object.keys(returnDetails.batchIds).filter(batchId => 
    //         returnDetails.batchIds[batchId].some(reason => reason.saleCondition === "Unsaleable")
    //       );
          
    //       const result = [];
          
    //       if (saleableBatchIds.length > 0) {
    //         result.push({
    //           "supplier":user.loginId,
    //           "skuCode":returnDetails.skuCode,
    //           "batchCode":returnDetails.batchCode,
    //           "price":returnDetails.ptr,
    //           "saleCondition":"Saleable",
    //           "caseQuantity":saleableBatchIds.reduce((acc, batchId) => acc + returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Saleable" ? reason.caseQty : 0), 0), 0),  
    //           "pieceQuantity":saleableBatchIds.reduce((acc, batchId) => acc + returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Saleable" ? reason.pieceQty : 0), 0), 0),
    //           "otherUnitQuantity":saleableBatchIds.reduce((acc, batchId) => acc + returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Saleable" ? reason.otherQty : 0), 0), 0),
    //           "batchIds":saleableBatchIds.map(batchId => ({
    //             "batchId":batchId,
    //             "caseQty":returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Saleable" ? reason.caseQty : 0), 0),
    //             "otherQty":returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Saleable" ? reason.otherQty : 0), 0),
    //             "pieceQty":returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Saleable" ? reason.pieceQty : 0), 0),
    //             "reasonDetails":returnDetails.batchIds[batchId].filter(reason => reason.saleCondition === "Saleable")
    //           })),
    //           "extendedAttributes":{
    //             "isNewSchemes":true,
    //             "saleCondition":"Saleable",
    //           }
    //         });
    //       }
          
    //       if (unsaleableBatchIds.length > 0) {
    //         result.push({
    //           "supplier":user.loginId,
    //           "skuCode":returnDetails.skuCode,
    //           "batchCode":returnDetails.batchCode,
    //           "price":0,
    //           "saleCondition":"Unsaleable",
    //           "caseQuantity":unsaleableBatchIds.reduce((acc, batchId) => acc + returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Unsaleable" ? reason.caseQty : 0), 0), 0),  
    //           "pieceQuantity":unsaleableBatchIds.reduce((acc, batchId) => acc + returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Unsaleable" ? reason.pieceQty : 0), 0), 0),
    //           "otherUnitQuantity":unsaleableBatchIds.reduce((acc, batchId) => acc + returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Unsaleable" ? reason.otherQty : 0), 0), 0),
    //           "batchIds":unsaleableBatchIds.map(batchId => ({
    //             "batchId":batchId,
    //             "caseQty":returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Unsaleable" ? reason.caseQty : 0), 0),
    //             "otherQty":returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Unsaleable" ? reason.otherQty : 0), 0),
    //             "pieceQty":returnDetails.batchIds[batchId].reduce((acc, reason) => acc + (reason.saleCondition === "Unsaleable" ? reason.pieceQty : 0), 0),
    //             "reasonDetails":returnDetails.batchIds[batchId].filter(reason => reason.saleCondition === "Unsaleable")
    //           })),
    //           "extendedAttributes":{
    //             "isNewSchemes":true,
    //             "saleCondition":"Unsaleable",
    //           }
    //         });
    //       }
          
    //       return result;
    //     }).filter(returnDetailsObject=>returnDetailsObject.caseQuantity+returnDetailsObject.otherUnitQuantity+returnDetailsObject.pieceQuantity),
    //     "extendedAttributes":{
    //       "isNewSchemes":true,
    //     }
    //   };
      // if(reqBody.salesDetails.length == 0){
      //   const outletDetails = await getOutletDetails(outletCode);
      //   const x = getDummySalesValidateResponseToCreateReturn(outletCode, salesRepId, outletDetails.length ? outletDetails[0].outletName : "", salesRepName);
      //   return x;
      // }
    // }
    reqBody = applyBatchIdSplitting(reqBody);
    const response:any = await ChannelkartNetworkPost("/v3/sales/validate?transformerOut=SalesValidateTransformer",reqBody);
    return response.data.feature[0];
}
export const validateReturnDetailsWithReturn = async(returnData:Invoice)=>{
    const batchDetailsMap = await getBatchDetailsFromDb();
    if(!batchDetailsMap){
      throw new Error("Return Details not found");
    }
    let reqBody;
      reqBody = {
        "invoiceNumber":"test",
        "loginId":returnData.loginId,
        "supplier":returnData.supplier,
        "source":"DMS",
        "type":"return",
        "outletCode":returnData.outletCode,
        "salesDetails":returnData.salesDetails.map(returnDetails=>({
            "supplier":returnData.supplier,
            "skuCode":returnDetails.skuCode,
            "price":returnDetails.price,
            "batchCode":returnDetails.batchCode,
            "caseQuantity":returnDetails.caseQuantity,
            "pieceQuantity":returnDetails.initialPieceQuantity,
            "otherUnitQuantity":returnDetails.otherUnitQuantity,
            "batchIds":returnDetails.batchIdDetails,
            "extendedAttributes":{}
        })).filter(returnDetailsObject=>returnDetailsObject.caseQuantity+returnDetailsObject.otherUnitQuantity+returnDetailsObject.pieceQuantity),
        "extendedAttributes":{
          "isNewSchemes":true,
        }
      };
    reqBody = applyBatchIdSplitting(reqBody);
    const response:any = await ChannelkartNetworkPost("/v3/sales/validate?transformerOut=SalesValidateTransformer",reqBody);
    return response.data.feature[0];
}

export const getEditSaleReturnRequest = async(returnData:Invoice)=>{
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const reasonMap: { [key: string]: string[] } = ConfigDictionary?.salesReturnReasonsMap ?? {};
  let productData: any = [];
      try {
          productData = (await getDataFromLocalDb("Product")).data[0].data;
      } catch (e) { }
  
  const batchIdConfiguration: boolean= ConfigDictionary?.batchIdConfiguration;
  if(Object.keys(reasonMap).length == 0){
    return {
      "invoiceNumber": returnData.invoiceNumber,
      "supplier": returnData.supplier,
      "loginId": returnData.loginId,
      "outletCode": returnData.outletCode,
      "type": "return",
      "extendedAttributes": {
          "returnStatus": "APPROVED",
          "isNewSchemes": true
      },
      "salesDetails": returnData.salesDetails.map(saleDetail=>{
        const batchIds = saleDetail.batchIds?.map(batchIdObject => {
          let caseQty = 0, pieceQty=0, otherQty=0;
          batchIdObject.reasonDetails?.forEach(reasonDetail => {
            caseQty += reasonDetail.caseQty;
            pieceQty += reasonDetail.pieceQty;
            otherQty += reasonDetail.otherQty;  
          })
          const updatedBatch = JSON.parse(JSON.stringify(batchIdObject));
          updatedBatch.caseQty = caseQty;
          updatedBatch.otherQty = otherQty;
          updatedBatch.pieceQty = pieceQty;
          return updatedBatch
        })
        return {
            "supplier": returnData.supplier,
            "skuCode": saleDetail.skuCode,
            "batchCode": saleDetail.batchCode,
            "productInfo":productData[saleDetail.skuCode],
            "pieceQuantity": batchIds?.reduce((total, batchId) => total + batchId.pieceQty, 0),
            "caseQuantity": batchIds?.reduce((total, batchId) => total + batchId.caseQty, 0),
            "otherUnitQuantity": batchIds?.reduce((total, batchId) => total + batchId.otherQty, 0),
            "batchIds": batchIds
        }
      })
    };
  }else{
    // Complex case - with reason map, split by sale condition
    const salesDetails = returnData.salesDetails.flatMap(saleDetail => {
      const saleableBatchIds = saleDetail.batchIds?.filter(batchIdObject => 
        batchIdObject.reasonDetails?.some(reason => reason.saleCondition === "Saleable")
      );
      const unsaleableBatchIds = saleDetail.batchIds?.filter(batchIdObject => 
        batchIdObject.reasonDetails?.some(reason => reason.saleCondition === "Unsaleable")
      );
      
      const result = [];

      if (saleableBatchIds && saleableBatchIds.length > 0) {
        const processedBatchIds = saleableBatchIds.map(batchIdObject => {
          let caseQty = 0, pieceQty = 0, otherQty = 0;
          batchIdObject.reasonDetails?.forEach(reasonDetail => {
            if (reasonDetail.saleCondition === "Saleable") {
              caseQty += reasonDetail.caseQty;
              pieceQty += reasonDetail.pieceQty;
              otherQty += reasonDetail.otherQty;
            }
          });
          const updatedBatch = JSON.parse(JSON.stringify(batchIdObject));
          updatedBatch.caseQty = caseQty;
          updatedBatch.otherQty = otherQty;
          updatedBatch.pieceQty = pieceQty;
          updatedBatch.reasonDetails = batchIdObject.reasonDetails?.filter(reason => reason.saleCondition === "Saleable");
          return updatedBatch;
        });
        
        result.push({
          "supplier": returnData.supplier,
          "skuCode": saleDetail.skuCode,
          "batchCode": saleDetail.batchCode,
          "extendedAttributes": {
            "saleCondition": "Saleable"
          },
          "saleCondition": "Saleable",
          "productInfo":productData[saleDetail.skuCode],
          "pieceQuantity": processedBatchIds.reduce((total, batchId) => total + batchId.pieceQty, 0),
          "caseQuantity": processedBatchIds.reduce((total, batchId) => total + batchId.caseQty, 0),
          "otherUnitQuantity": processedBatchIds.reduce((total, batchId) => total + batchId.otherQty, 0),
          "batchIds": processedBatchIds
        });
      }
      
      if (unsaleableBatchIds && unsaleableBatchIds.length > 0) {
        const processedBatchIds = unsaleableBatchIds.map(batchIdObject => {
          let caseQty = 0, pieceQty = 0, otherQty = 0;
          batchIdObject.reasonDetails?.forEach(reasonDetail => {
            if (reasonDetail.saleCondition === "Unsaleable") {
              caseQty += reasonDetail.caseQty;
              pieceQty += reasonDetail.pieceQty;
              otherQty += reasonDetail.otherQty;
            }
          });
          const updatedBatch = JSON.parse(JSON.stringify(batchIdObject));
          updatedBatch.caseQty = caseQty;
          updatedBatch.otherQty = otherQty;
          updatedBatch.pieceQty = pieceQty;
          updatedBatch.reasonDetails = batchIdObject.reasonDetails?.filter(reason => reason.saleCondition === "Unsaleable");
          return updatedBatch;
        });
        
        result.push({
          "supplier": returnData.supplier,
          "skuCode": saleDetail.skuCode,
          "batchCode": saleDetail.batchCode,
          "extendedAttributes": {
            "saleCondition": "Unsaleable"
          },
          "saleCondition": "Unsaleable",
          "productInfo":productData[saleDetail.skuCode],
          "pieceQuantity": processedBatchIds.reduce((total, batchId) => total + batchId.pieceQty, 0),
          "caseQuantity": processedBatchIds.reduce((total, batchId) => total + batchId.caseQty, 0),
          "otherUnitQuantity": processedBatchIds.reduce((total, batchId) => total + batchId.otherQty, 0),
          "batchIds": processedBatchIds
        });
      }
      
      return result;
    });

    let reqBody = {
      "invoiceNumber": returnData.invoiceNumber,
      "supplier": returnData.supplier,
      "loginId": returnData.loginId,
      "outletCode": returnData.outletCode,
      "type": "return",
      "extendedAttributes": {
          "returnStatus": "APPROVED",
          "isNewSchemes": true
      },
      "salesDetails": salesDetails
    };
    if(batchIdConfiguration){
      reqBody = applyBatchIdSplitting(reqBody);
    }
    return reqBody;
  }
}


export const applyBatchIdSplitting = (
  reqBody: any
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const batchIdConfiguration: boolean= ConfigDictionary?.batchIdConfiguration;
  if (!batchIdConfiguration) {
    return reqBody;
  }

  const transformedSalesDetails = reqBody.salesDetails.flatMap((salesDetail: SalesDetail) => {
    return salesDetail.batchIds?.map(batchIdObject => {
      return {
        ...salesDetail,
        "pieceQuantity": batchIdObject.pieceQty,
        "caseQuantity": batchIdObject.caseQty,
        "otherUnitQuantity": batchIdObject.otherQty,
        "batchId": batchIdObject.batchId,
        "batchIds": [
          batchIdObject
        ]
      }
    })
  }).filter((salesDetail:any) => salesDetail && (salesDetail.caseQuantity || salesDetail.otherUnitQuantity || salesDetail.pieceQuantity));
  return { ...reqBody, salesDetails: transformedSalesDetails };
};

export const getReturnWithoutInvoiceReqBody = async(outletCode:string, returnDetails: ReturnSkuDetail[], salesRepId?:string)=>{
  const user = JSON.parse(localStorage.authContext).user;
  const productDetails = await getProductDetailsFromDb();
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const reasonMap: { [key: string]: string[] } = ConfigDictionary?.salesReturnReasonsMap ?? {};
  const batchIdConfiguration: boolean= ConfigDictionary?.batchIdConfiguration;
  let reqBodyBody;
  if(Object.keys(reasonMap).length == 0){
    reqBodyBody= {
      "supplier": user.loginId,
      "loginId": salesRepId ?? user.loginId,
      "outletCode": outletCode,
      "source":"DMS",
      "type":"return",
      "extendedAttributes": {
          "returnStatus": "APPROVED",
          "isNewSchemes": true,
      },
      "salesDetails": returnDetails.map(returnDetail=>({
        "supplier": user.loginId,
        "skuCode":returnDetail.skuCode,
        "productInfo":productDetails[returnDetail.skuCode],
        "batchCode":returnDetail.batchCode,
        "price":returnDetail.ptr,
        "pieceQuantity":returnDetail.pieceQuantity,
        "caseQuantity":returnDetail.caseQuantity,
        "otherUnitQuantity":returnDetail.otherUnitQuantity,
        "batchIds":Object.keys(returnDetail.batchIds).map(batchId=>({
          "batchId":batchId,
          "caseQty":Object.values(returnDetail.batchIds[batchId]).reduce((acc, current) => acc + current.caseQty, 0),
          "otherQty":Object.values(returnDetail.batchIds[batchId]).reduce((acc, current) => acc + current.otherQty, 0),
          "pieceQty":Object.values(returnDetail.batchIds[batchId]).reduce((acc, current) => acc + current.pieceQty, 0),
          "reasonDetails":Object.values(returnDetail.batchIds[batchId])
        }))
      }))
    }
  }else{
    reqBodyBody= {
      "supplier": user.loginId,
      "loginId": salesRepId ?? user.loginId,
      "outletCode": outletCode,
      "source":"DMS",
      "type":"return",
      "extendedAttributes": {
          "returnStatus": "APPROVED",
          "isNewSchemes": true,
      },
             "salesDetails": returnDetails.flatMap(returnDetail=>{
         const saleableBatchIds = Object.keys(returnDetail.batchIds).filter(batchId => 
           returnDetail.batchIds[batchId].some(reason => reason.saleCondition === "Saleable")
         );
         const unsaleableBatchIds = Object.keys(returnDetail.batchIds).filter(batchId => 
           returnDetail.batchIds[batchId].some(reason => reason.saleCondition === "Unsaleable")
         );
         
         const result = [];
         
         if (saleableBatchIds.length > 0) {
           result.push({
             "supplier": user.loginId,
             "extendedAttributes":{
              "saleCondition":"Saleable",
             },
             "skuCode": returnDetail.skuCode,
             "productInfo":productDetails[returnDetail.skuCode],
             "batchCode": returnDetail.batchCode,
             "price": returnDetail.ptr,
             "saleCondition":"Saleable",
             "pieceQuantity": saleableBatchIds.reduce((total, batchId) => 
               total + returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Saleable" ? reason.pieceQty : 0), 0), 0),
             "caseQuantity": saleableBatchIds.reduce((total, batchId) => 
               total + returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Saleable" ? reason.caseQty : 0), 0), 0),
             "otherUnitQuantity": saleableBatchIds.reduce((total, batchId) => 
               total + returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Saleable" ? reason.otherQty : 0), 0), 0),
             "batchIds": saleableBatchIds.map(batchId => ({
               "batchId": batchId,
               "caseQty": returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Saleable" ? reason.caseQty : 0), 0),
               "otherQty": returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Saleable" ? reason.otherQty : 0), 0),
               "pieceQty": returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Saleable" ? reason.pieceQty : 0), 0),
               "reasonDetails": returnDetail.batchIds[batchId].filter(reason => reason.saleCondition === "Saleable")
             }))
           });
         }
         
         if (unsaleableBatchIds.length > 0) {
           result.push({
             "supplier": user.loginId,
             "skuCode": returnDetail.skuCode,
             "productInfo":productDetails[returnDetail.skuCode],
             "batchCode": returnDetail.batchCode,
             "price": 0,
             "extendedAttributes":{
              "saleCondition":"Unsaleable",
             },
             "saleCondition":"Unsaleable",
             "pieceQuantity": unsaleableBatchIds.reduce((total, batchId) => 
               total + returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Unsaleable" ? reason.pieceQty : 0), 0), 0),
             "caseQuantity": unsaleableBatchIds.reduce((total, batchId) => 
               total + returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Unsaleable" ? reason.caseQty : 0), 0), 0),
             "otherUnitQuantity": unsaleableBatchIds.reduce((total, batchId) => 
               total + returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Unsaleable" ? reason.otherQty : 0), 0), 0),
             "batchIds": unsaleableBatchIds.map(batchId => ({
               "batchId": batchId,
               "caseQty": returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Unsaleable" ? reason.caseQty : 0), 0),
               "otherQty": returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Unsaleable" ? reason.otherQty : 0), 0),
               "pieceQty": returnDetail.batchIds[batchId].reduce((acc, reason) => 
                 acc + (reason.saleCondition === "Unsaleable" ? reason.pieceQty : 0), 0),
               "reasonDetails": returnDetail.batchIds[batchId].filter(reason => reason.saleCondition === "Unsaleable")
             }))
           });
         }
         return result;
       })
    }
  }
  
  reqBodyBody= applyBatchIdSplitting(reqBodyBody);
  return reqBodyBody;
}

const getDummySalesValidateResponse = async (returnData:Invoice) => {
  const outletDetails = await getOutletDetailsMap();
  let salesRepDetails:any;
  try{
    salesRepDetails = (await ChannelkartNetworkGet(`/users/mapped/hierarchy?filter=activeStatus:active and designation[in]:[salesman] and loginId:${returnData.loginId}&size=10`)).data.features[0];
  }catch(e){}
  const outletName = outletDetails[returnData.outletCode]?.outletName ?? "";
  return {
    "activeStatus": "inactive",
    "source": "DMS",
    "changes": [],
    "changed": true,
    "extendedAttributes": {
        "isNewSchemes": true,
        "postProcess": "true"
    },
    "initialAmount": 0,
    "netAmount": 0,
    "billAmount": 0,
    "mrp": returnData.mrp,
    "type": "return",
    "validate": true,
    "update": false,
    "supplierHierarchy": returnData.supplierHierarchy,
    "supplier": returnData.supplier,
    "locationHierarchy": returnData.locationHierarchy,
    "normalizedVolume": 0,
    "loginId": returnData.loginId,
    "outletCode": returnData.outletCode,
    "invoiceNumber": returnData.invoiceNumber,
    "totalQuantity": 0,
    "totalInitialQuantity": 0,
    "normalizedQuantity": 0,
    "initialNormalizedQuantity": 0,
    "userExists": true,
    "outletExists": true,
    "salesDetails": [
    ],
    "inBeat": false,
    "inRange": false,
    "stockAllocationDisabled": false,
    "create": false,
    "totalCaseQuantity": 0,
    "totalPieceQuantity": 0,
    "totalOtherUnitQuantity": 0,
    "salesRepId": returnData.loginId,
    "salesRepName": salesRepDetails?.name ?? "",
    "totalAmount": 0,
    "outletName": outletName,
    "supplierName": returnData.supplier,
    "totalDiscountValue": 0,
    "couponValue": 0,
    "discountValue": 0,
    "additionalDistributorDiscount": 0,
    "hasGstin": false,
    "lineCount": 0
  }
}

const getDummySalesValidateResponseToCreateReturn = (outletCode:string, salesRepId:string, outletName:string, salesRepName:string) => {
  const user = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
  return {
    "activeStatus": "inactive",
    "source": "DMS",
    "changes": [],
    "changed": true,
    "extendedAttributes": {
        "isNewSchemes": true,
        "postProcess": "true"
    },
    "initialAmount": 0,
    "netAmount": 0,
    "billAmount": 0,
    "mrp": 0,
    "type": "return",
    "validate": true,
    "update": false,
    "supplierHierarchy": "",
    "supplier": user.loginId,
    "locationHierarchy": "",
    "normalizedVolume": 0,
    "loginId": salesRepId,
    "outletCode": outletCode,
    "invoiceNumber": "test",
    "totalQuantity": 0,
    "totalInitialQuantity": 0,
    "normalizedQuantity": 0,
    "initialNormalizedQuantity": 0,
    "userExists": true,
    "outletExists": true,
    "salesDetails": [
    ],
    "inBeat": false,
    "inRange": false,
    "stockAllocationDisabled": false,
    "create": false,
    "totalCaseQuantity": 0,
    "totalPieceQuantity": 0,
    "totalOtherUnitQuantity": 0,
    "salesRepId": salesRepId,
    "salesRepName": salesRepName,
    "totalAmount": 0,
    "outletName": outletName,
    "supplierName": user.name,
    "totalDiscountValue": 0,
    "couponValue": 0,
    "discountValue": 0,
    "additionalDistributorDiscount": 0,
    "hasGstin": false,
    "lineCount": 0
  }
}

export const getRouteOutletList = async (routeId: string) => {
  const response = await ChannelkartNetworkGet(`/v1/entitymapping/dynamic?filter=entityCategory:beatMapping and entityType:beat and filter1:${routeId}`);
  return response.data.features.map((item: any) => item.entityId);
}

export const getRouteAndOutletDataMap = async () => {
  let allFeatures: any[] = [];
  let currentPage = 0;
  let totalPages = 1;

  while (currentPage < totalPages) {
    const response = await ChannelkartNetworkGet(
      `/v1/entitymapping/dynamic?filter=entityCategory:beatMapping and entityType:beat&page=${currentPage}&size=1000`
    );

    const data = response.data;
    totalPages = data.totalPage || 1;

    if (data.features && data.features.length > 0) {
      allFeatures.push(...data.features);
    }

    currentPage++;
  }

  const outletToRoutesMap: Record<string, Set<string>> = {};
  const routeToOutletsMap: Record<string, Set<string>> = {};

  for (const item of allFeatures) {
    const outletCode = item.entityId;
    const routeId = item.filters?.routeId;

    if (!outletCode || !routeId) continue;

    // Map: outletCode -> routeId
    if (!outletToRoutesMap[outletCode]) {
      outletToRoutesMap[outletCode] = new Set();
    }
    outletToRoutesMap[outletCode].add(routeId);

    // Map: routeId -> outletCode
    if (!routeToOutletsMap[routeId]) {
      routeToOutletsMap[routeId] = new Set();
    }
    routeToOutletsMap[routeId].add(outletCode);
  }

  return {
    outletToRoutesMap,
    routeToOutletsMap
  };
};
